export enum StorageKeyEnum {
  CURRENT_USER = 'currentUser',
  TUI_LANGUAGE = 'tuiLanguage',
  ACCESS_TOKEN = 'accessToken',
  REFRESH_TOKEN = 'refreshToken',
}

export enum CategoryKeyEnum {
  Parent = 'Parent',
  Adult = 'Adult',
  Child = 'Child',
}

export enum UserRole {
  User,
  UserPremium,
  Admin,
}
